// index.js – Einstiegspunkt der React-App (Create React App): startet die Einwilligungsprüfung und rendert <App />.
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { starteEinwilligung } from "./consent";

// PostHog und Google Ads starten nur, wenn eine Einwilligung gespeichert ist (Banner: src/Banner.jsx)
starteEinwilligung();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
